import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import {
  IsEnum,
  IsNumber,
  IsObject,
  IsOptional,
  IsString,
} from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

import {
  EWithdrawalKycProvider,
  EWithdrawalKycStatus,
} from './withdrawal-kyc.enums';
import { WithdrawalKycPayloadSummaryDto } from './withdrawal-kyc.entity';

@Index(['eventKey'], { unique: true })
export class WithdrawalKycEvent extends BasicEntity {
  @ApiProperty({ required: false })
  @IsOptional()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: true })
  userId?: number | null;

  @ApiProperty()
  @IsEnum(EWithdrawalKycProvider, { groups: ['error'] })
  @Column({ type: 'varchar', enum: EWithdrawalKycProvider, nullable: false })
  provider: EWithdrawalKycProvider;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: false })
  eventKey: string;

  @ApiProperty()
  @IsEnum(EWithdrawalKycStatus, { groups: ['error'] })
  @Column({ type: 'varchar', enum: EWithdrawalKycStatus, nullable: false })
  status: EWithdrawalKycStatus;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: false })
  providerVerificationId: string;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: true })
  providerAttemptId?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: true })
  decisionCode?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'text', nullable: true })
  decisionReason?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsObject({ groups: ['error'] })
  @Column({ type: 'jsonb', nullable: true })
  payloadSummary?: WithdrawalKycPayloadSummaryDto | null;
}
